import { Container, Card } from "react-bootstrap";
import { Button } from "@mui/material";
import staff from "../assets/team.png";
import course from "../assets/books.png";
import event from "../assets/event.png";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { createTheme, ThemeProvider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import wechatLogo from "../assets/RCS_Wechat_QRcode.png"
import customTheme from "../components/CustomTheme";
import HomeGallery from "../components/HomeGallery";

function Home() {

  // const theme = createTheme({
  //   components: {
  //     MuiButton: {
  //       styleOverrides: {
  //         root: {
  //           backgroundColor: "#9B1119",
  //           color: "#fff",
  //           '&:hover': {
  //             backgroundColor: '#fff',
  //             color: "#9B1119"
  //           },
  //           fontSize: "1rem",
  //         }
  //       }
  //     }
  //   }
  // });
  const themeWhite = createTheme({
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            backgroundColor: "#fff",
            color: '#9B1119',
            '&:hover': {
              backgroundColor: '#9B1119',
              color: '#fff'
            },
            fontSize: "1rem",
          }
        }
      }
    }
  });

  const navigate = useNavigate();


  return (
    <div className="homeDiv">
      <div>
        <Container fluid className=" homeContainer">

        </Container>
        <div className="homeOverlay" >
          <p className="homeOverlayLargeBold " >Welcome to Reading Chinese School</p>


          <div className="gallery_and_event" style={{ width: "90%", margin: "0px auto" }} >
            <div className='gallery_column'>
              <HomeGallery />
              <ThemeProvider theme={themeWhite} >
                <Button variant="contained" style={{ width: "80%", fontSize: '0.9rem' }} onClick={() => { navigate("/gallery"); window.scrollTo(0, 0); }} endIcon={<ChevronRightIcon />} >Go To Gallery</Button>
              </ThemeProvider>
            </div>
            <div className='event_column_2'>

              <h3>热烈祝贺我校IGCSE考生全部荣获A*优异成绩！</h3>

              <div style={{
                border: "2px solid white",
                padding: "5px",
                marginTop: "5px",
                minWidth: "90%"
              }}>
                <h3
                  style={{
                    borderBottom: "2px solid white",
                    paddingBottom: "10px",
                    marginBottom: "15px"
                  }}
                >
                  Upcoming major events
                </h3>
                <p></p>


                <h4>PTA Cake Sale - 13/12/2026 </h4>
                <h4>GCSE Graduation Ceremony - TBC</h4>

              </div>


            </div >
          </div>





        </div >
      </div>

      <Container className="homeAbout">
        <h1 className="homeOverlayLarge">About us</h1>
        <div >
          <p className="homeOverlayMedium">雷丁中文学校成立于1978年，我们的宗旨是向雷丁地区所有想学习了解中文和中华文化的人教授普通话以及中华文化。</p>
          <p className="homeOverlayMedium">Reading Chinese School was established in 1978. The school's aim is to provide education in both Chinese language and culture for children and adults of all ages and backgrounds. </p>
        </div>
        <Container className="cardContainer">
          <Card className="me-4 mb-4 pt-5 pb-5  col-md-4 box-shadow text-center">
            <Card.Img variant="top" style={{ minHeight: "100px" }} src={staff} alt="teacher" />
            <Card.Body>
              <Card.Text className="homeCardText">
                <span>中文母语老师</span> <br />
                <span> Native Chinese teachers</span>
              </Card.Text>
              {/* <Button variant="primary">Go somewhere</Button> */}
            </Card.Body>
          </Card>
          <Card className="me-4  mb-4 pt-5 pb-5 col-md-4 box-shadow text-center">
            <Card.Img variant="top" style={{ minHeight: "100px" }} src={course} alt="courses" />
            <Card.Body>

              <Card.Text className="homeCardText">
                <span>适合各种水平的中文课程</span> <br />
                <span>Courses for all levels</span>
              </Card.Text>
              {/* <Button variant="primary">Go somewhere</Button> */}
            </Card.Body>
          </Card>
          <Card className="me-4  mb-4 pt-5 pb-5  col-md-4 box-shadow text-center">
            <Card.Img variant="top" style={{ minHeight: "100px" }} src={event} alt="events" />
            <Card.Body>

              <Card.Text className="homeCardText">
                <span>丰富多彩的文化活动</span> <br />
                <span>Rich and colorful cultural <br /> activities</span>
              </Card.Text>
              {/* <Button variant="primary">Go somewhere</Button> */}
            </Card.Body>
          </Card>

        </Container>

        <div >
          <p className="homeOverlayMedium"> 雷丁中文学校欢迎三岁以上的所有学生加入这个美妙的中国语言文化学习旅程. </p>
          <p className="homeOverlayMedium">Reading Chinese School welcome students from all level (ages from 3 years old) to join our fantastic Chinese language and cultural learning journey. </p>

        </div>

        <div className="lessonTime">
          <div>
            <p className="homeOverlayMedium" >
              上课时间:<br /> 逢周日 10：00-12：00</p>

            <p className="homeOverlayMedium">Lesson time: <br />every Sunday 10:00-12:00</p>
            <p className="homeOverlayMedium">
              Address 地址:
              <br />
              Highdown School and Sixth Form Centre </p>
            {/* Highdown School<br />Surley Row, Emmer Green<br />Reading RG4 8LR</p> */}
          </div>

          <img src={wechatLogo} width={"300px"} alt="Wechat Logo" min-height="150px"></img>
        </div>


        <div className="moreButtonDiv">
          <ThemeProvider theme={customTheme}>
            <Button variant="contained" className="buttonStyle mb-5" onClick={() => { navigate("/contact"); window.scrollTo(0, 0); }}
              endIcon={<ChevronRightIcon />} > More About Us</Button>
          </ThemeProvider>
        </div>


      </Container>
    </div >
  )

}

export default Home;


// {/* // gallery and event */}
// <div className="gallery_and_event" style={{ width: "100%", margin: "0px auto" }} >
//   <div className='gallery_column'>
//     <HomeGallery />
//     <ThemeProvider theme={themeWhite} >
//       <Button variant="contained" style={{ width: "80%", fontSize: '0.9rem' }} onClick={() => { navigate("/gallery"); window.scrollTo(0, 0); }} endIcon={<ChevronRightIcon />} >Go To Gallery</Button>
//     </ThemeProvider>
//   </div>
//   <div className='event_column_2' textAlign='center'>
//     <h3>Congratulations to our school for winning the Pride of Reading Awards 2025 - Cultural Contribution Award!</h3>
//     <p></p>
//     <div className="gallery_and_event">
//       <img className="gallery_column_2" src={PrideOfReading} alt="Open day" width={"25%"} /><p className="event_column">
//         <a href="https://mp.weixin.qq.com/s/jE6LckmAGkIF1plEav4ifQ?from=groupmessage&scene=1&subscene=10000&clicktime=1761168739&enterid=1761168739 " target="_blank" rel="noopener noreferrer" style={{ color: 'white' }}>
//           <h4 style={{ marginLeft: "10px" }}>喜讯！雷丁中文学校荣获2025年度文化贡献大奖'Cultural Contribution Award'</h4></a></p>
//     </div>
//   </div>
// </div >
// {/* //end here */}

//new year poster
//   {/* <div className="posterAndBooking" style={{ width: "50%", margin: "1px auto" }} >
//       {/* new year poster */}
//   {/* <img src={newyearposter} alt="New Year Poster" width={"49%"} />
//   <ThemeProvider theme={themeWhite}>
//     <Button as="a" href="https://whatsonreading.com/chinese-new-year-celebration-2026" target="_blank" rel="noopener noreferrer"
//       variant="contained" style={{
//         textDecoration: "none", marginTop: "2px",
//         width: "49%", textAlign: "center", fontSize: "1rem"
//       }}> Book Ticket</Button>
//   </ThemeProvider>

// </div> */ }


/* // gallery and event */
// <div className="gallery_and_event" style={{ width: "90%", margin: "0px auto" }} >
//   <div className='gallery_column'>
//     <HomeGallery />
//     <ThemeProvider theme={themeWhite} >
//       <Button variant="contained" style={{ width: "80%", fontSize: '0.9rem' }} onClick={() => { navigate("/gallery"); window.scrollTo(0, 0); }} endIcon={<ChevronRightIcon />} >Go To Gallery</Button>
//     </ThemeProvider>
//   </div>
//   <div className='event_column_2'>

//     <p></p>
//     <p></p>
//     <button onClick={() => { navigate("/courses/extra"); window.scrollTo(0, 0); }} style={{
//       color: 'white', background: "none", border: "none", cursor: "pointer", textDecoration: "underline", textAlign: "left", padding: "0"
//     }}>
//       <h3>好消息！舞蹈班招生啦！Dance class now enrolling!</h3></button>

//     <div style={{
//       border: "2px solid white",
//       padding: "5px",
//       marginTop: "5px",
//       minWidth: "90%"
//     }}>
//       <h3
//         style={{
//           borderBottom: "2px solid white",
//           paddingBottom: "10px",
//           marginBottom: "15px"
//         }}
//       >
//         Upcoming major events
//       </h3>
//       <p></p>


//       <h4>09/05/2026  -  Children’s Day Performance</h4>
//       <h4>07/06/2026  -  School Annual Meeting</h4>
//       <h4>14/06/2026  -  Open day</h4>

//     </div>
{/* 
              <a href="https://mp.weixin.qq.com/s/W7U5q0PqcKOH0_2rFiGtaQ" target="_blank" rel="noopener noreferrer" style={{ color: 'white' }}>
                <h4>瑞马迎春，文化共融——英国雷丁2026马年新春庆祝活动圆满举办</h4></a> */}
{/* <p></p>
              <a href="https://rdg.today/reading-celebrates-chinese-new-year-with-dragon-dance-and-cultural-festivities/" target="_blank" rel="noopener noreferrer" style={{ color: 'white' }}>
                <h4>Reading celebrates Chinese New Year with dragon dance and cultural festivities</h4></a> */}
{/* </div>

          </div > */}
/* //end here */



//summer holiday
// <div style={{
//   border: "2px solid white",
//   padding: "5px",
//   marginTop: "5px",
//   minWidth: "90%"
// }}>
//   <h3
//     style={{
//       borderBottom: "2px solid white",
//       paddingBottom: "10px"
//     }}
//   >
//     We are now closed for the summer holiday. Classes will resume on 06/09/2026.<br />
//     <p></p>
//     We wish all our students and families a happy, safe, and enjoyable summer break!<br />

//   </h3>


//   {/* <a href="https://mp.weixin.qq.com/s/RN3bW2Q6-IU2F7i1Rw3flA" target="_blank" rel="noopener noreferrer" style={{ color: 'white' }}>
//     <h4 style={{ marginLeft: "0px" }}>这一年，我们一起成长——雷丁中文学校2026学年结业典礼暨运动会圆满举行</h4></a> */}
//   <p></p>
//   <a href="https://docs.google.com/forms/d/e/1FAIpQLScjKU2DUsMuk0S3jrgQNcBbEx87HSrI16yzechw1faCO3bYQQ/viewform?usp=header" target="_blank" rel="noopener noreferrer" style={{ color: 'white' }}>
//     <h4 style={{ marginLeft: "0px" }}>2026-2027 Registration form</h4></a>



// </div>